export const SAVED = 'saved';
export const CLICKED_PLAY = 'clickedPlay';
export const CLICKED_PAUSE = 'clickedPause';
export const CLICKED_RESET = 'clickedReset';
export const TOGGLED_VIEW = 'toggledView';
export const TOGGLED_TEMPERATURE_SCALE = 'toggledTemperatureScale';
export const TOGGLED_ELECTRONS_ON = 'toggledElectronsOn';
export const TOGGLED_ELECTRONS_OFF = 'toggledElectronsOff';
export const TOGGLED_GRID_ON = 'toggledGridOn';
export const TOGGLED_GRID_OFF = 'toggledGridOff';
export const TOGGLED_RADIATION_ON = 'toggledRadiationOn';
export const TOGGLED_RADIATION_OFF = 'toggledRadiationOff';
export const TOGGLED_WAVELENGTH_DISTRIBUTION_ON =
  'toggledWavelengthDistributionOn';
export const TOGGLED_WAVELENGTH_DISTRIBUTION_OFF =
  'toggledWavelengthDistributionOff';
